<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="840px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    append-to-body
    v-el-dialog-drag
  >
    <div>
      <div class="images-container">
        <div v-if="!disabled">
          <div class="d-flex align-items-center">
            <div>
              <el-upload
                id="uploader"
                ref="uploader"
                multiple
                action="#"
                :file-list="listImageFile"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="uploadChange"
                accept=".jpeg,.jpg,.png,.gif"
              >
                <b-button class="mr-2" size="sm" variant="outline-primary">
                  <i class="el-icon-folder" />
                  {{ $l('table_label_choose_file') || '选择文件' }}
                </b-button>
              </el-upload>
            </div>
          </div>
        </div>

        <div class="fabric-edit-images">
          <div v-if="!isEmpty" class="fabric-edit-images-wrapper">
            <div
              v-for="(item, index) in listImage"
              :key="index"
              class="fabric-edit-images-item"
            >
              <div class="fabric-edit-images-item-box">
                <el-image
                  fit="scale-down"
                  :src="item.fileUrl"
                  :preview-src-list="listImageUrl"
                ></el-image>

                <div class="fabric-edit-images-item-shadow">
                  <div>
                    <span @click="onImagePreview(index)">
                      <i class="el-icon-zoom-in"></i
                    ></span>

                    <span
                      v-if="!disabled"
                      @click="onImageDel(item, index)"
                      class="ml-2"
                    >
                      <i class="el-icon-delete-solid"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isEmpty" class="fabric-edit-images-empty">
            <div style="text-align: center">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data mt-2">
                {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
        <img
          v-for="(item, index) in listImageUrl"
          :src="item || '/image/static/img/nopic.jpg'"
          :key="index"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { sizeOf } from '@/libs/util'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    inspectionCode: { type: String, default: '' },
    inspectionDefectCode: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    title: { type: String, default: '上传码单照片' },
  },
  data() {
    return {
      listImage: [],
      listImageFile: [],
      uploadFileMaxLimit: 10,
    }
  },
  watch: {},
  computed: {
    isEmpty() {
      return !this.listImage || !this.listImage.length
    },
    listImageUrl() {
      return this.isEmpty ? [] : this.listImage.map((item) => item.fileUrl)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.inspectionCode) return
      const res = await this.$api
        .inspectionDefectImageListApi({
          inspectionCode: this.inspectionCode,
          inspectionDefectCode: this.inspectionDefectCode,
        })
        .catch(() => null)
      this.listImage = res.body.data
    },
    uploadChange(file) {
      const $uploader = this.$refs.uploader
      const uploader = $uploader.$el.querySelectorAll('input')[0]

      const listFile = uploader.files
      const fileCount = listFile.length

      if (fileCount > this.uploadFileMaxLimit) {
        const msg = `当前限制选择 ${this.uploadFileMaxLimit} 张图片，本次选择了 ${fileCount} 张图片`
        this.$message.warning(msg)
        this.clearFiles()
        throw new Error(msg)
      }
      this.listImageFile.push(file)
      if (this.listImageFile.length !== fileCount) return false
      this.upload()
    },
    async upload() {
      if (!this.listImageFile || !this.listImageFile.length) {
        this.$message.warning('请选择您需要上传的图片！')
        return
      }

      this.loadingOpen()
      const listImage = await this.uploadImages()
      if (listImage.includes(null)) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败',
        )
        this.loadingClose()
        this.clearFiles()
        return
      }

      const params = {
        inspectionCode: this.inspectionCode,
        inspectionDefectCode: this.inspectionDefectCode,
        imageList: listImage,
      }
      const res = await this.$api
        .inspectionDefectImageSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      this.clearFiles()
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败',
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })
      this.getData()
    },
    uploadImages() {
      if (!this.listImageFile || !this.listImageFile.length) {
        return Promise.resolve([])
      }
      const uploadTask = this.listImageFile.map(({ raw }) => {
        return this.$api
          .SYS_UPLOAD(raw)
          .then((res) => ({
            fileCode: res.body.fileId,
            fileUrl: res.body.url,
            fileType: 'M',
            fileName: raw.name,
            fileSize: raw.size,
            fileSizeText: raw.size ? sizeOf(raw.size) : 0,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
    clearFiles() {
      this.$refs.uploader.clearFiles()
      this.listImageFile = []
    },
    onImagePreview(index) {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.view(index)
      viewer.show()
    },
    onImageDel({ inspectionImageCode }, index) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .inspectionDefectImageDelApi({ inspectionImageCode })
          .catch(() => null)
        this.loadingClose()
        const { status } = res
        if (status !== 200) {
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          return
        }
        this.getData()
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
          type: 'success',
        })
      })
    },
    // async onImageCheck({ inspectionImageCode }) {
    //   this.loadingOpen()
    //   const res = await this.$api
    //     .ecomAmzSampleImageSetDefaultApi({ inspectionImageCode })
    //     .catch(() => null)
    //   this.loadingClose()
    //   const { status } = res
    //   if (status !== 200) {
    //     this.$message.error(this.$l('INDEX.tips_set_no') || '设置失败！')
    //     return
    //   }
    //   this.getData()
    //   this.$message({
    //     showClose: true,
    //     message: this.$l('INDEX.tips_set_ok') || '设置成功！',
    //     type: 'success',
    //   })
    // },
    close() {
      this.$emit('closeImage')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.images-container {
  height: 500px;
}

.fabric-edit-images {
  height: calc(100vh - 460px);
  min-height: 460px;
  overflow-y: auto;
  margin: 10px 0px;

  .fabric-edit-images-wrapper {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    .fabric-edit-images-item {
      .fabric-edit-images-item-box {
        position: relative;
        display: flex;
        border-radius: 6px;
        border: 1px solid #c0ccda;
        .el-image {
          width: 140px;
          height: 140px;
        }

        .fabric-edit-images-item-shadow {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          right: 0;
          bottom: 0;
          top: 0;
          left: 0;
          border-radius: 6px;
          opacity: 0;
          transition: opacity 0.3s;

          i {
            color: #fff;
            font-size: 20px;
            cursor: pointer;
          }
        }
      }

      .fabric-edit-images-item-box:hover {
        .fabric-edit-images-item-shadow {
          background-color: rgba(0, 0, 0, 0.5);
          opacity: 1;
        }
      }
    }
  }

  .fabric-edit-images-empty {
    height: calc(100vh - 510px);
    min-height: 420px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
